module.exports = __webpack_public_path__ + "static/img/img2.18ce3d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/double11/2/img2.png
// module id = EDLx
// module chunks = 0